/**
 * Determines whether to format a [[MonetaryValue]] inclusive or exclusive of tax.
 */
export var TaxMode;
(function (TaxMode) {
    /**
     * Formats a [[MonetaryValue]] with its value including tax.
     */
    TaxMode["Inclusive"] = "Inclusive";
    /**
     * Formats a [[MonetaryValue]] with its value excluding tax.
     */
    TaxMode["Exclusive"] = "Exclusive";
})(TaxMode || (TaxMode = {}));
//# sourceMappingURL=tax-mode.js.map